import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ENTRY_AVATAR_IMAGE_URLS } from '../../../assets/entryAvatarUrls';
import { AvatarShowcase } from './avatarShowcase';
export const CustomAvatarShowcase = () => (_jsx(AvatarShowcase, { title: 'Custom Avatars!', subTitle: 'Make your "poker face".', imageUrls: ENTRY_AVATAR_IMAGE_URLS, isAvatarOnLeft: true }));
